import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Event } from "./Event";
import { ListOfEvents } from "./EventComponents/ListOfEvents/ListOfEvents";
import { ReservationEventPage } from "./EventComponents/ReservationEventPage/ReservationEventPage";
import { getAuthenticated } from "utils/functions";

export const EventLinkRouting = () => {
  const isAuthenticated = getAuthenticated();
  const isAuth =
    localStorage.getItem("memberPortal") === "true" ? isAuthenticated : false;

  const { eventData } = useSelector((state) => state?.Events);

  const eventLoaded = Object.keys(eventData).length > 0;

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/events/" component={ListOfEvents} />
        <Route
          exact
          path="/events/:id/reservation"
          render={({ match }) => {
            const notAllowed = eventLoaded && !eventData?.allowNonMembers && !isAuth;
            return notAllowed ? (
              <Redirect to={`/events/${match.params.id}`} />
            ) : (
              <ReservationEventPage />
            );
          }}
        />
        <Route exact path="/events/:id" component={Event} />
      </Switch>
    </BrowserRouter>
  );
};
